export default __webpack_public_path__ + "static/media/AddEdit.e19fc6fd.svg";